module.exports = __webpack_public_path__ + "img/20210618_072659.f5dd4ac5.jpg";